import * as React from 'react';
import {pipelineobj} from '../../Entity/SSOObj';
import  './pipeline.scss';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

import { DirectionalHint,IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';




export interface IProps{
    data?: pipelineobj;     
    UpdateMethod;
    LogTitle;
   SaveText;
}

export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  isCalloutVisible?: boolean;  
  SalesLog:string;
}

export default class PipelineLogEdit extends React.Component<IProps,IContextualMenuState,IContextualMenuItem>{
  /*state: IProps = {
   
  };*/
  
  private _menuButtonElement: HTMLElement | null;
  
  constructor(props: IProps) {
    super(props); 
    this.state = {
      isCalloutVisible: false,      
      directionalHint: DirectionalHint.topCenter,
      beakWidth:16,      
      SalesLog:props.data.SalesLog
    };  
    
  }
  public handleLogChange= (event): void => {
    this.setState({SalesLog: event.target.value});
  }
   
  
  public AddSummary=(event)=>{
    let summarytext=this.state.SalesLog;
    if (summarytext == "") {
      summarytext=this.props.LogTitle;
  }
  else {
    summarytext=this.props.LogTitle + "\n\n" + summarytext;
  }
    this.setState({SalesLog:summarytext});
  }
  public render() {
    //let rowcss="ms-Grid-row miparow";
    
    const { isCalloutVisible, beakWidth } = this.state;
    
    return (     
         
        
               <label id={'Callout_'+this.props.data.ID} title={this.props.data.SalesLog} ref={menuButton => (this._menuButtonElement = menuButton)}>
                <i className='ms-Icon ms-Icon--ActivityFeed' onClick={this._onShowMenuClicked} ></i>
               
                {isCalloutVisible ? (
                              <Callout
                                
                                className="ms-Callout-callout"
                                onDismiss={this._onCalloutDismiss}
                                target={this._menuButtonElement}
                                //directionalHint={directionalHint}
                                coverTarget={false}
                                isBeakVisible={true}
                                gapSpace={0}
                                beakWidth={beakWidth}
                              >
           
                              <div className="ms-Callout-inner" style={{padding:'10px'}}>
                                <div className="ms-Callout-content">
                                <i style={{fontSize:20,float:'left',marginRight:5,color:'#0098d9',cursor:'pointer'}} onClick={this.AddSummary} className="timestamp ms-Icon ms-Icon--BufferTimeBoth"></i>
                                <textarea onChange={this.handleLogChange} cols={40} rows={10} value={this.state.SalesLog}></textarea>
                                  
                                </div>
                                <div style={{textAlign:"right",padding:5}}>
                                    <DefaultButton style={{background: '#8a41a5',color: '#fff'}}  
                                                  onClick={(event)=>{
                                                    this.UpdateSSOValue(this.props.data.ID,this.state.SalesLog,'IGlobeCRM_SSO_SalesLog','Note',this.props.data.SSOColmn);
                                                    this._onCalloutDismiss();
                                                    }} text={this.props.SaveText} />
                                </div>
            </div>
          </Callout>
        ) : null}    
         </label> 
        
      
    );
  }
  

  public UpdateSSOValue=(itemId,newValue,propName,type,col)=>{
    let SSOObj = {
              listtitle: 'SSO List',
              ID:itemId,
              fieldslist: [{
                spfieldname:propName,
                spvalue:newValue,
                spfieldtype:type
              }]
          };
          
          
     this.props.UpdateMethod(SSOObj,col,true);
  }
  private _onCalloutDismiss = (): void => {
    this.setState({
      isCalloutVisible: false
    });
  }

  private _onShowMenuClicked = (): void => {
    this.setState({
      isCalloutVisible: !this.state.isCalloutVisible
    });
  }
}
